<template>
    <q-layout view="hHh lpR fFf">
    </q-layout>
</template>

<script>
    import LoginDialogModel from './logindialog.vue';

    export default {
        mounted: function () {
            this.$q.dialog({
                component: LoginDialogModel,
                parent: this,
                returnUrl: this.$route.query.ReturnUrl
            });
        },
    }
</script>
